module.exports = __webpack_public_path__ + "media/images/present-icon-2c8ec52ff0e28d8f94b9ac3b3cdb8653.png";